"use client";
import { jsx } from "react/jsx-runtime";
import { useTheme } from "../../../hooks/useTheme.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Modal as Modal$1, Box } from "@mantine/core";
import { forwardRef } from "react";
import '../../../assets/Modal.css';const root = "_root_8ez62_2";
const overlay = "_overlay_8ez62_6";
const inner = "_inner_8ez62_10";
const title = "_title_8ez62_14";
const ModalStyles = {
  root,
  overlay,
  inner,
  title
};
const _Modal = forwardRef((props, ref) => {
  const { children, title: title2, className, ...rest } = props;
  const theme = useTheme();
  return /* @__PURE__ */ jsx(
    Modal$1,
    {
      ...rest,
      withinPortal: true,
      lockScroll: true,
      centered: true,
      closeOnEscape: true,
      closeOnClickOutside: true,
      fullScreen: false,
      trapFocus: false,
      classNames: ModalStyles,
      className,
      overlayProps: {
        blur: 3,
        opacity: 0.55,
        color: theme.other.colorTokens.backgrounds.neutral
      },
      title: title2,
      children: /* @__PURE__ */ jsx(Box, { ref, children })
    }
  );
});
_Modal.displayName = "Modal";
const Modal = sharedHandler(_Modal);
Modal.displayName = _Modal.displayName;
export {
  ModalStyles as M,
  Modal as default
};
